var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "po-create-page main-content" }, [
    !_vm.initLoading
      ? _c(
          "form",
          {
            attrs: { action: "" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                _vm.submitPurchaseOrderData((_vm.redirectPOAttachment = false))
              },
            },
          },
          [
            _c("div", { staticClass: "page-header" }, [
              _vm.$route.name === "purchase-orders.edit"
                ? _c("h3", { staticClass: "page-title" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("pos.edit_po")) + "\n      "
                    ),
                  ])
                : _c("h3", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.$t("pos.new_po"))),
                  ]),
              _vm._v(" "),
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/anchor/dashboard" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/anchor/purchase-orders",
                        },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$tc("pos.po", 2)))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$route.name === "purchase-orders.edit"
                  ? _c("li", { staticClass: "breadcrumb-item" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pos.edit_po")) +
                          "\n        "
                      ),
                    ])
                  : _c("li", { staticClass: "breadcrumb-item" }, [
                      _vm._v(_vm._s(_vm.$t("pos.new_po"))),
                    ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-actions row" },
                [
                  _vm.$route.name === "purchase-orders.edit"
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "mr-3 base-button btn btn-outline-primary default-size invoice-action-btn",
                          attrs: {
                            href:
                              "/purchaseOrders/pdf/" +
                              _vm.newPurchaseOrder.unique_hash,
                            target: "_blank",
                            outline: "",
                            color: "theme",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("general.view_pdf")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xs-2 mr-4" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: {
                            outline: true,
                            icon: "file",
                            size: "large",
                            color: "theme",
                            "right-icon": "",
                          },
                          on: { click: _vm.POAttchements },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$tc("pos.attachments", 2)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "invoice-action-btn",
                      attrs: {
                        loading: _vm.isLoading,
                        disabled: _vm.isLoading,
                        icon: "save",
                        color: "theme",
                        type: "submit",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("pos.save_po")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row po-input-group" }, [
              _c(
                "div",
                { staticClass: "col-md-5 po-customer-container" },
                [
                  _vm.selectedSupplier
                    ? _c("div", { staticClass: "show-customer" }, [
                        _c("div", { staticClass: "row px-2 mt-1" }, [
                          _vm.selectedSupplier
                            ? _c("div", { staticClass: "col col-12" }, [
                                _c("div", { staticClass: "row address-menu" }, [
                                  _c(
                                    "label",
                                    { staticClass: "col-sm-4 px-2 title" },
                                    [_vm._v(_vm._s(_vm.$t("general.supplier")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm p-0 px-2 content" },
                                    [
                                      _vm.selectedSupplier.name
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier.name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedSupplier.billing_address
                            ? _c("div", { staticClass: "col col-6" }, [
                                _c("div", { staticClass: "row address-menu" }, [
                                  _c(
                                    "label",
                                    { staticClass: "col-sm-4 px-2 title" },
                                    [_vm._v(_vm._s(_vm.$t("general.bill_to")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm p-0 px-2 content" },
                                    [
                                      _vm.selectedSupplier.billing_address.name
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.billing_address
                                        .address_street_1
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address
                                                    .address_street_1
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.billing_address
                                        .address_street_2
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address
                                                    .address_street_2
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.billing_address
                                        .city &&
                                      _vm.selectedSupplier.billing_address.state
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.city
                                                ) +
                                                ",\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.state
                                                ) +
                                                "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.zip
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.billing_address
                                        .country
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.country
                                                    .name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.billing_address.phone
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .billing_address.phone
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedSupplier.shipping_address
                            ? _c("div", { staticClass: "col col-6" }, [
                                _c("div", { staticClass: "row address-menu" }, [
                                  _c(
                                    "label",
                                    { staticClass: "col-sm-4 px-2 title" },
                                    [_vm._v(_vm._s(_vm.$t("general.ship_to")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm p-0 px-2 content" },
                                    [
                                      _vm.selectedSupplier.shipping_address.name
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address.name
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.shipping_address
                                        .address_street_1
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address
                                                    .address_street_1
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.shipping_address
                                        .address_street_2
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address
                                                    .address_street_2
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.shipping_address
                                        .city &&
                                      _vm.selectedSupplier.shipping_address
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address.city
                                                ) +
                                                ",\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address.state
                                                ) +
                                                "\n                    " +
                                                _vm._s(
                                                  _vm.selectedSupplier
                                                    .shipping_address.zip
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.shipping_address
                                        .country
                                        ? _c(
                                            "label",
                                            { staticClass: "country" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.selectedSupplier
                                                      .shipping_address.country
                                                      .name
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedSupplier.shipping_address
                                        .phone
                                        ? _c(
                                            "label",
                                            { staticClass: "phone" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.selectedSupplier
                                                      .shipping_address.phone
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "customer-content mb-1" }, [
                          _c("label", { staticClass: "email" }, [
                            _vm._v(_vm._s(_vm.selectedSupplier.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "action",
                              on: { click: _vm.removeSupplier },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.deselect")))]
                          ),
                        ]),
                      ])
                    : _c(
                        "base-popup",
                        {
                          class: [
                            "add-customer",
                            {
                              "customer-required":
                                _vm.$v.selectedSupplier.$error,
                            },
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "add-customer-action",
                              attrs: { slot: "activator" },
                              slot: "activator",
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "customer-icon",
                                attrs: { icon: "user" },
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("suppliers.new_supplier")) +
                                      "\n                "
                                  ),
                                  _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(" * "),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.$v.selectedSupplier.$error &&
                                !_vm.$v.selectedSupplier.required
                                  ? _c("p", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("pos.errors.required")
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("supplier-select-popup", {
                            attrs: { type: "purchaseOrder" },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col po-input" }, [
                _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("reports.pos.po_date"))),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$v.newPurchaseOrder.purchase_order_date.$touch()
                          },
                        },
                        model: {
                          value: _vm.newPurchaseOrder.purchase_order_date,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newPurchaseOrder,
                              "purchase_order_date",
                              $$v
                            )
                          },
                          expression: "newPurchaseOrder.purchase_order_date",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newPurchaseOrder.purchase_order_date.$error &&
                      !_vm.$v.newPurchaseOrder.purchase_order_date.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("pos.due_date"))),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          invalid: _vm.$v.newPurchaseOrder.expiry_date.$error,
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$v.newPurchaseOrder.expiry_date.$touch()
                          },
                        },
                        model: {
                          value: _vm.newPurchaseOrder.expiry_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.newPurchaseOrder, "expiry_date", $$v)
                          },
                          expression: "newPurchaseOrder.expiry_date",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newPurchaseOrder.expiry_date.$error &&
                      !_vm.$v.newPurchaseOrder.expiry_date.required
                        ? _c("span", { staticClass: "text-danger mt-1" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("validation.required"))
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("pos.supplier_bank_name"))),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          invalid:
                            _vm.$v.newPurchaseOrder.supplier_bank_name.$error,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.newPurchaseOrder.supplier_bank_name.$touch()
                          },
                        },
                        model: {
                          value: _vm.newPurchaseOrder.supplier_bank_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newPurchaseOrder,
                              "supplier_bank_name",
                              $$v
                            )
                          },
                          expression: "newPurchaseOrder.supplier_bank_name",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newPurchaseOrder.supplier_bank_name.$error &&
                      !_vm.$v.newPurchaseOrder.supplier_bank_name.required
                        ? _c("div", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("pos.buyer_bank_name"))),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          invalid:
                            _vm.$v.newPurchaseOrder.buyer_bank_name.$error,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.newPurchaseOrder.buyer_bank_name.$touch()
                          },
                        },
                        model: {
                          value: _vm.newPurchaseOrder.buyer_bank_name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newPurchaseOrder,
                              "buyer_bank_name",
                              $$v
                            )
                          },
                          expression: "newPurchaseOrder.buyer_bank_name",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newPurchaseOrder.buyer_bank_name.$error &&
                      !_vm.$v.newPurchaseOrder.buyer_bank_name.required
                        ? _c("div", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col collapse-input" },
                    [
                      _c("label", [_vm._v(_vm._s(_vm.$t("pos.ref_num")))]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          invalid:
                            _vm.$v.newPurchaseOrder.reference_number.$error,
                          icon: "hashtag",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.$v.newPurchaseOrder.reference_number.$touch()
                          },
                        },
                        model: {
                          value: _vm.newPurchaseOrder.reference_number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.newPurchaseOrder,
                              "reference_number",
                              $$v
                            )
                          },
                          expression: "newPurchaseOrder.reference_number",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$v.newPurchaseOrder.reference_number.$error
                        ? _c("div", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$tc("validation.ref_number_maxlength")
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "item-table" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("thead", { staticClass: "item-table-header" }, [
                  _c("tr", [
                    _c("th", { staticClass: "text-left row" }, [
                      _c(
                        "span",
                        { staticClass: "column-heading item-heading col-md-6" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$tc("items.item", 2)) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "column-heading item-heading col-md-6" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$tc("items.part_number", 2)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-right" }, [
                      _c("span", { staticClass: "column-heading" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("pos.item.quantity")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-left" }, [
                      _c("span", { staticClass: "column-heading" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("pos.item.price")) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-right" }, [
                      _c(
                        "span",
                        { staticClass: "column-heading amount-heading" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("pos.item.amount")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  {
                    staticClass: "item-body",
                    attrs: { tag: "tbody", handle: ".handle" },
                    model: {
                      value: _vm.newPurchaseOrder.items,
                      callback: function ($$v) {
                        _vm.$set(_vm.newPurchaseOrder, "items", $$v)
                      },
                      expression: "newPurchaseOrder.items",
                    },
                  },
                  _vm._l(_vm.newPurchaseOrder.items, function (item, index) {
                    return _c("PO-item", {
                      key: item.id,
                      attrs: {
                        index: index,
                        "item-data": item,
                        currency: _vm.currency,
                        "order-items": _vm.newPurchaseOrder.items,
                        "tax-per-item": _vm.taxPerItem,
                        "discount-per-item": _vm.discountPerItem,
                      },
                      on: {
                        remove: _vm.removeItem,
                        update: _vm.updateItem,
                        itemValidate: _vm.checkItemsData,
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-item-action", on: { click: _vm.addItem } },
              [
                _c("font-awesome-icon", {
                  staticClass: "mr-2",
                  attrs: { icon: "shopping-basket" },
                }),
                _vm._v("\n      " + _vm._s(_vm.$t("pos.add_item")) + "\n    "),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "po-foot" }, [
              _c(
                "div",
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("pos.notes")))]),
                  _vm._v(" "),
                  _c("base-text-area", {
                    attrs: { rows: "3", cols: "50" },
                    on: {
                      input: function ($event) {
                        return _vm.$v.newPurchaseOrder.notes.$touch()
                      },
                    },
                    model: {
                      value: _vm.newPurchaseOrder.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.newPurchaseOrder, "notes", $$v)
                      },
                      expression: "newPurchaseOrder.notes",
                    },
                  }),
                  _vm._v(" "),
                  _vm.$v.newPurchaseOrder.notes.$error
                    ? _c("div", [
                        !_vm.$v.newPurchaseOrder.notes.maxLength
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(_vm.$t("validation.notes_maxlength"))
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticClass: "mt-3 mb-1 d-block" }, [
                    _vm._v(_vm._s(_vm.$t("pos.po_template")) + "\n          "),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "btn-template",
                      attrs: {
                        type: "button",
                        icon: "pencil-alt",
                        "right-icon": "",
                      },
                      on: { click: _vm.openTemplateModal },
                    },
                    [
                      _c("span", { staticClass: "mr-4" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("pos.po_template")) +
                            " " +
                            _vm._s(_vm.getTemplateId) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "po-total" }, [
                _c("div", { staticClass: "section" }, [
                  _c("label", { staticClass: "po-label" }, [
                    _vm._v(_vm._s(_vm.$t("pos.sub_total"))),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "po-amount" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(_vm.subtotal, _vm.currency)
                        ),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section border-top mt-3" }, [
                  _c("label", { staticClass: "po-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("pos.total")) +
                        " " +
                        _vm._s(_vm.$t("pos.amount")) +
                        ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "po-amount total" }, [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(_vm.total, _vm.currency)
                        ),
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "40%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "10%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "15%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }